export function redirect(location) {
    return (window.location = location);
  }